/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface ISocial {
  /** Название социальной сети **/
  name: string;
  /** Ссылка на страницу в социальной сети **/
  url: string;
  /** Тип соцсети (для выставления иконки) **/
  type: EType;
}

export enum EType {
  /** ВКонтакте **/
  Vk = 'vk',
  /** Telegram **/
  Telegram = 'telegram',
  /** Youtube **/
  Youtube = 'youtube',
  /** Instagram **/
  Instagram = 'instagram',
}
